import type { SubjectCode } from '~/models/Subject'
import { getColor } from '~/utils/colors'
import { ColorName } from '~/models/Content/Color'

const subjectColorMap: Record<SubjectCode | string, ColorName> = {
  'NOR': ColorName.Yellow40,
  'MAT': ColorName.OrangePop,
  'ENG': ColorName.CoralPop,
  'SAF': ColorName.VioletPop,
  'NAT': ColorName.BluePop,
  'KRL': ColorName.GreenPop,
  'TYS': ColorName.Green10,
  'FRA': ColorName.Purple20,
  'SPA': ColorName.Yellow20,
  'KRO': ColorName.Coral20,
  'MHE': ColorName.Orange20,
  'KHV': ColorName.Violet20,
  'MUS': ColorName.Seagreen20,
  'TVE': ColorName.Yellow30,
  'Biblioteket': ColorName.PurplePop,
  'Terminprøver': ColorName.Blue20,
  'Papir+': ColorName.White,
  'bokstøtte': ColorName.Yellow10,
  'lydstøtte': ColorName.Orange10,
  'white': ColorName.White,
}

export default () => {
  const getStyles = (name: SubjectCode | string) => {
    const color = getColor(subjectColorMap[name] ?? ColorName.Green10)

    return {
      '--color': color,
    }
  }

  return {
    getStyles,
  }
}
